import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; // Common Angular directives (e.g., ngIf, ngFor)
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // For template-driven and reactive forms

// Shared components, directives, pipes

import { AssignedCarsComponent } from '../assigned-cars/assigned-cars.component';
import { SurrenderCarsComponent } from '../surrender-cars/surrender-cars.component';
import { UnassignedCarsComponent } from '../unassigned-cars/unassigned-cars.component';
import { VipCarsComponent } from '../vip-cars/vip-cars.component';
import { TabControlComponent } from '../vdms_shared/utils/tabs/tab-control.component';
import { TabPageComponent } from '../vdms_shared/utils/tabs/tab-page.component';
import { VdmsTabsComponent } from './vdms-tabs.component';
import { NgxPaginationModule } from "ngx-pagination";
import { StringToDateAndRenewalPipe } from '../vdms_shared/pipes/renewal.status';
import { StringToDatePipe } from '../vdms_shared/pipes/StringToDatePipe';
import { statusColorText } from '../vdms_shared/pipes/status.pipes';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { columnnFilterPipe } from '../vdms_shared/pipes/filter.pipes';
import { AllVehiclesComponent } from '../all-vehicles/all-vehicles.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { Ng2OrderModule } from "ng2-order-pipe";

@NgModule({
  declarations: [
    VdmsTabsComponent,
    TabControlComponent,
    TabPageComponent,
    AssignedCarsComponent,
    SurrenderCarsComponent,
    UnassignedCarsComponent,
    VipCarsComponent,
    AllVehiclesComponent,
    StringToDateAndRenewalPipe,
    StringToDatePipe,
    statusColorText,
    columnnFilterPipe
  ],
  imports: [
    CommonModule,           // CommonModule gives access to ngIf, ngFor, etc.
    FormsModule,            // Import FormsModule and ReactiveFormsModule if needed
    ReactiveFormsModule,
    NgxPaginationModule,
    Ng2OrderModule,
   // Ng4LoadingSpinnerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
   
  ],
  exports: [
    CommonModule,           // Re-export common Angular modules and any custom components, pipes, directives
    FormsModule,
    ReactiveFormsModule,
    VdmsTabsComponent,
    TabControlComponent,
    TabPageComponent,
    AssignedCarsComponent,
    SurrenderCarsComponent,
    UnassignedCarsComponent,
    VipCarsComponent,
    NgxPaginationModule,
    AllVehiclesComponent,
   // Ng4LoadingSpinnerModule
  ],

  providers:[
    StringToDateAndRenewalPipe,
    StringToDatePipe,
    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] // Add this line
})
export class VdmsSharedModule { }
